<template>
  <qc-container v-if="goods" title="商品编辑" show-divider show-return>
    <el-form ref="goodsForm" :model="goods"  label-width="120px">
      <h4 class="form-title">商品信息</h4>
      <form-item-rule label="商品标题" prop="name">
        <el-input v-model="goods.name" placeholder="请输入商品标题" style="width: 800px;"></el-input>
      </form-item-rule>
      <form-item-rule label="商品编码" prop="codes">
        <el-input v-model="goods.codes" placeholder="请输入商品编码" style="width: 800px;"></el-input>
      </form-item-rule>
      <form-item-rule label="商品品牌" prop="brandId">
        <simple-dict dict-type="brand" :type="0" tipsValue="商品品牌" v-model="goods.brandId"></simple-dict>
      </form-item-rule>
      <form-item-rule label="商品分类" prop="classifyId">
        <classify-dict dict-type="shopType" type="0" tipsValue="商品分类" v-model="goods.classifyId"></classify-dict>
      </form-item-rule>
      <el-form-item label="商品图片" prop="pictureList">
        <drafting-upload-img @getPictureList="getPicture" :init-picture-list="goods.pictureList"></drafting-upload-img>
      </el-form-item>
      <el-form-item label="商品属性">
        <div class="attribute-talbe">
          <table class="av-talbe">
            <tr>
              <td colspan="2" class="tips">
                <h5>操作提示</h5>
                <p>1、双击规格值进行编辑操作(回车按钮保存)。</p>
              </td>
            </tr>
            <tr v-for="(attribute, index) in attributeList">
              <td class="attribute-name">
                <el-tag :key="attribute.name" closable type="success" @close="deleteAttribute(index)">
                  {{ attribute.name }}
                </el-tag>
              </td>
              <td>
                <el-tag :queryKey="tag" :key="index" v-for="tag in attribute.dynamicTags" closable
                        :disable-transitions="false" @close="handleClose(tag,index)">
                  {{ tag }}
                </el-tag>
                <el-input class="input-new-tag attribute-input" v-if="attribute.inputVisible"
                          v-model="attribute.inputValue" size="small"
                          @keyup.enter.native="handleInputConfirm"
                          @blur="handleInputConfirm">
                </el-input>
                <el-button v-else class="button-new-tag" size="small" @click="showInput(index)">+ 添加属性值</el-button>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <el-button type="text" @click="addAttribute(1)">添加属性</el-button>
              </td>
            </tr>
          </table>
        </div>
      </el-form-item>
      <el-form-item label="商品库存" v-if="goodsStock">
        <div class="attribute-talbe">
          <el-table :data="sockList" :span-method="arraySpanMethod" border style="width: 100%">
            <el-table-column v-for="(title,titleIndex) in stockTitle" :label="title">
              <template #default="scope">
                {{ sockList && sockList[scope.$index] && sockList[scope.$index] && sockList[scope.$index].list && sockList[scope.$index].list[titleIndex] && sockList[scope.$index].list[titleIndex].name }}
              </template>
            </el-table-column>
            <el-table-column v-if="goods.storeGoodsType!=1" label="销售价格（元）" width="180">
              <template #default="scope">
                <el-input style="width: 100px" v-model="scope.row.salesPrice"></el-input>
              </template>
            </el-table-column>
            <el-table-column v-if="goods.storeGoodsType==1||goods.storeGoodsType==2" label="租用价格（元）" width="180">
              <template #default="scope">
                <el-input style="width: 100px" v-model="scope.row.marketPrice"></el-input>
              </template>
            </el-table-column>
            <el-table-column v-if="goods.storeGoodsType!=1" label="销售库存" width="180">
              <template #default="scope">
                <el-input style="width: 100px" v-model="scope.row.inventory"></el-input>
              </template>
            </el-table-column>
            <el-table-column v-if="goods.storeGoodsType==1||goods.storeGoodsType==2" label="租赁库存" width="180">
              <template #default="scope">
                <el-input style="width: 100px" v-model="scope.row.marketInventory"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="重量（kg）" width="180">
              <template #default="scope">
                <el-input style="width: 100px" v-model="scope.row.weight"></el-input>
              </template>
            </el-table-column>
            <!--            <el-table-column prop="sales" label="销量" width="180"></el-table-column>-->
          </el-table>
          <div class="batch-but">
            批量设置：
            <el-button v-if="goods.storeGoodsType!=1" type="primary" @click="batchBut(1)">销售价格</el-button>
            <el-button v-if="goods.storeGoodsType==1||goods.storeGoodsType==2" type="primary" @click="batchBut(2)">租用价格</el-button>
            <el-button v-if="goods.storeGoodsType!=1" type="primary" @click="batchBut(3)">出售库存</el-button>
            <el-button v-if="goods.storeGoodsType==1||goods.storeGoodsType==2" type="primary" @click="batchBut(4)">租赁库存</el-button>
            <el-button type="primary" @click="batchBut(5)">重量</el-button>
          </div>
        </div>
      </el-form-item>
      <template v-if="attributeList.length===0">
        <form-item-rule label="销售价格" v-if="goods.storeGoodsType!=1" prop="salesPrice">
          <el-input-number class="w200" v-model="goods.salesPrice" :precision="2" :step="0.1"
                           :min="0.1"></el-input-number>
        </form-item-rule>
        <form-item-rule v-if="goods.storeGoodsType==1||goods.storeGoodsType==2" label="租用价格" prop="marketPrice">
          <el-input-number class="w200" v-model="goods.marketPrice" :precision="2" :step="0.1"
                           :min="0.1"></el-input-number>
        </form-item-rule>
        <form-item-rule label="销售库存" v-if="goods.storeGoodsType!=1" prop="inventory" >
          <el-input-number class="w200" v-model="goods.inventory"  controls-position="right" :min="0" :max="999999">
          </el-input-number>
        </form-item-rule>
        <form-item-rule label="租赁库存" v-if="goods.storeGoodsType==1||goods.storeGoodsType==2" prop="marketInventory" >
          <el-input-number class="w200" v-model="goods.marketInventory"  controls-position="right" :min="0" :max="999999">
          </el-input-number>
        </form-item-rule>
        <form-item-rule label="重量(kg)" prop="weight">
          <el-input-number class="w200" v-model="goods.weight" :precision="2" :step="0.1" :min="0.1"></el-input-number>
        </form-item-rule>
      </template>
      <form-item-rule label="商品原价" v-if="goods.storeGoodsType!=1" prop="salesPrice">
        <el-input-number class="w200" v-model="goods.price" :precision="2" :step="0.1" :min="0.1"></el-input-number>
      </form-item-rule>
      <form-item-rule label="租赁押金" v-if="goods.storeGoodsType==1 || goods.storeGoodsType==2" prop="integralNum">
        <el-input-number class="w200" v-model="goods.integralNum" :precision="2" :step="0.1" :min="0.1"></el-input-number>
      </form-item-rule>
      <el-form-item label="商品详情" prop="goodsDetails">
        <div>
          <Ueditor ref="editor"></Ueditor>
        </div>
      </el-form-item>
      <form-item-rule label="运费模板" v-if="goods.storeGoodsType!=1">
        <el-select v-model="goods.templateId">
          <el-option :label="item.name+ (item.isDefault===1?'(默认)':'')" :value="item.id" :key="item.id" v-for="item in templateList"></el-option>
        </el-select>
      </form-item-rule>
      <el-form-item >
        <el-button @click="returnLast">返回</el-button>
        <el-button type="primary" @click="saveGoods()">保存</el-button>
      </el-form-item>
    </el-form>
  </qc-container>

  <!-- 添加属性dialog-->
  <el-dialog title="添加属性" v-model="addAttributeDialog" width="25%">
    <el-form ref="addAttributeForm" :model="attribute" label-width="80px">
      <el-form-item label="规格名称">
        <el-input v-model="attribute.name"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
       <el-button @click="addAttributeDialog = false">取 消</el-button>
       <el-button type="primary" @click="attributeSave()">确 定</el-button>
      </span>
  </el-dialog>


  <!-- 批量设置-->
  <el-dialog :title="batchTitle" v-model="batchDialog" width="25%">
    <el-form label-width="80px">
      <el-form-item :label="batchName">
        <el-input v-model="batchValue"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
       <el-button @click="batchDialog = false">取 消</el-button>
       <el-button type="primary" @click="batchSave()">确 定</el-button>
      </span>
  </el-dialog>
</template>

<script>
import QcContainer from "@/components/el/layout/qc-container";
import DraftingUploadImg from "@/components/upload/DraftingUploadImg";
import ClassifyDict from "@/components/dict/ClassifyDict";
import Ueditor from "@/components/base/ueditor";
import FormItemRule from "@/components/el/form-item-rule.vue";
import SimpleBtn from "@/components/base/simple-btn.vue";
import SimpleDict from "@/components/dict/SimpleDict.vue";


export default {
  name: "edit",
  components: {
    SimpleDict,
    SimpleBtn,
    FormItemRule,
    Ueditor, ClassifyDict, DraftingUploadImg, QcContainer
  },
  data() {
    return {
      goods: {
        id: '',
        orgId: '',
        classifyId: '',
        brandId:'',
        picture: '',
        name: '',
        salesPrice: '',
        marketPrice: 0,
        weight: 1,
        codes: '',
        inventory: '',
        warningInventory: '',
        area: '440106',
        freight: '',
        enables: 1,
        state: 1,
        isAttribute: 0,
        goodsDetails: '',
        pictureList: [],
        attributeList: [],
        sockList: [],
        provinces: '',
        city: '',
        region: '',
        countryType: 0,
        country: "",
        exportStatus: 0,
        taxRateId: '',
        taxRatePrice: 0,
        goodsType:0,
        storeGoodsType:0
      },
      type: 0,
      isFreight: false,
      index: 0,
      addAttributeDialog: false,
      attribute: {name: ''},
      goodsStock: false,
      attributeList: [],
      pictureList: [],
      stockTitle: [],
      sockList: [],
      areaDesc: '广东省/广州市/天河区',
      batchDialog: false,
      batchType: 0,
      batchTitle: '',
      batchName: '',
      batchValue: '',
      taxRateOption: [],
      taxPateProps: {value: "id", label: "name", checkStrictly: true, emitPath: false},
      countryOption: [],
      templateList:[],
    }
  },
  methods: {
    loadTemplate(){
      this.simplePost("/api/mgr/business/freight/list",{orgId:this.goods.orgId},result=>{
        this.templateList = result.data;
        result.data.forEach(row=>{
          if(row.isDefault===1&&(!this.goods.templateId)){
            this.goods.templateId = row.id;
          }
        })
      },false)
    },
    returnLast: function () {
      history.back(-1);
    },
    //添加属性弹出框
    addAttribute(id) {
      this.attribute = {name: ''};
      this.addAttributeDialog = true;
    },
    //属性保存
    attributeSave(id) {
      this.$refs['addAttributeForm'].validate((valid) => {
        if (valid) {
          this.addAttributeDialog = false;
          this.attributeList.push({name: this.attribute.name, inputVisible: false, inputValue: '', dynamicTags: []})
        }
      });

    },
    //添加属性值框
    showInput(index) {
      this.index = index;
      this.attributeList[index].inputVisible = true;
    },
    //保存属性值
    handleInputConfirm() {
      let index = this.index;
      this.attributeList[index].inputVisible = false;
      this.initAttribute(index);
    },
    //重新渲染表格
    initAttribute(index) {
      let attribute = this.attributeList[index];
      let inputValue = this.attributeList[index].inputValue;
      if (inputValue) {
        attribute.dynamicTags.push(inputValue);
      }

      this.attributeList[index].inputValue = '';
      if (this.attributeList.length > 0) {
        this.goodsStock = true;
      } else {
        this.goodsStock = false;
      }

      this.sockList = [];
      this.stockTitle = [];
      this.setStockTitle();
      this.setStockTr();
    },
    //关闭标签
    handleClose(tag, index) {
      this.attributeList[index].dynamicTags.splice(this.attributeList[index].dynamicTags.indexOf(tag), 1);

      if (this.attributeList.length > 0) {
        this.goodsStock = true;
      } else {
        this.goodsStock = false;
      }

      this.sockList = [];
      this.stockTitle = [];
      this.setStockTitle();
      this.setStockTr();
    },
    //删除属性
    deleteAttribute(index) {
      var attributeList = this.attributeList;
      var newAttributeList = new Array();
      for (var i = 0, l = attributeList.length; i < l; i++) {
        if (i != index) {
          newAttributeList.push(attributeList[i]);
        }
      }
      this.attributeList = newAttributeList;
      if (this.attributeList.length > 0) {
        this.setStockTitle();
        this.setStockTr();
      } else {
        this.goodsStock = false;
        this.sockList = [];
        this.stockTitle = [];
        this.attributeList = [];
      }

    },
    //属性头部属性
    setStockTitle() {
      let newStockTitle = new Array();
      for (let i = 0, leg = this.attributeList.length; i < leg; i++) {
        newStockTitle.push(this.attributeList[i].name);
      }
      this.stockTitle = newStockTitle;
    },
    //组装tr
    setStockTr() {
      var num = 1;
      var list = this.attributeList;

      if (list.length > 0) {
        //获取总行数
        for (var i = 0, leng = list.length; i < leng; i++) {
          num = num * (list[i].dynamicTags.length);
        }
        //初始化数组
        this.sockList = [];
        //写入第一行
        this.firstList(this.attributeList[0].dynamicTags, num);

        //属性大于2
        if (this.attributeList.length > 2) {
          this.otherList(num);
        }
        if (this.attributeList.length > 1) {
          //写入最后一行
          this.lastList(this.attributeList[this.attributeList.length - 1].dynamicTags, num);
        }

      }
    },
    //获取第一行
    firstList(list, num) {
      //获取第一行循环次数
      let zNum = num / list.length;
      let cswz = 0;//位置
      for (let i = 0; i < list.length; i++) {
        for (let ni = 0; ni < zNum; ni++) {
          let state = false;
          if (ni == 0) {
            state = true;
          }
          let obj = {name: list[i], rowspan: zNum, queryKey: 1 + "" + (i + 1), state: state};
          this.sockList[cswz] = {
            list: [obj],
            salesPrice: '',
            marketPrice: '',
            inventory: '',
            codes: '',
            weight: 0,
            sales: 0
          };
          cswz++;
        }
      }
    },
    //写入其他行数
    otherList(num) {
      var list = this.attributeList;

      //写入除最后一行外所有数据
      for (var i = 1, leng = list.length; i < leng - 1; i++) {
        var key = (i + 1) + "";
        var dList = list[i].dynamicTags;//当前选项
        var xNum = list[i - 1].dynamicTags.length;//循环次数
        //获取循环次数
        var xNum = 1;
        for (var xi = (i - 1); xi >= 0; xi--) {
          xNum = xNum * (list[xi].dynamicTags.length);
        }
        //获取每个值占行数
        var xLeng = 1;
        for (var ri = (i + 1); ri < list.length; ri++) {
          xLeng = xLeng * list[ri].dynamicTags.length;
        }

        var cswz = 0;//初始化位置

        for (var xi = 0; xi < xNum; xi++) {
          for (var di = 0, dl = dList.length; di < dl; di++) {
            for (var hi = 0; hi < xLeng; hi++) {
              var obj = {name: dList[di], rowspan: xLeng, queryKey: key + (di + 1), state: false};
              if (hi == 0) {
                obj.state = true;
              }
              var osList = this.sockList[cswz].list;
              obj.queryKey = osList[osList.length - 1].queryKey + "-" + obj.queryKey;
              this.sockList[cswz].list.push(obj);
              cswz++;
            }
          }
        }
      }
    },
    //获取最后一行
    lastList(list, num) {
      //获取最后一行循环次数
      var key = this.attributeList.length + "";
      var zNum = num / list.length;
      var cswz = 0;
      for (var numi = 0; numi < zNum; numi++) {
        for (var listi = 0, leng = list.length; listi < leng; listi++) {
          var dList = this.sockList[cswz].list;
          var queryKey = dList[dList.length - 1].queryKey + "-" + key + (listi + 1);
          this.sockList[cswz].list.push({name: list[listi], rowspan: 1, queryKey: queryKey, state: true});
          cswz++;
        }
      }
    },
    getPicture(data) {
      this.pictureList = data;
      this.goods.pictureList = data;
    },
    cityChange(city) {
      this.goods.area = city.cityCode;
      this.goods.provinces = city.provinces;
      this.goods.city = city.city;
      this.goods.region = city.region;
    },
    //保存修改
    saveGoods() {
      this.goods.goodsDetails = this.$refs.editor.getContent();
      this.goods.goodsDetails = this.goods.goodsDetails.replaceAll("<img", "<img style=\"width: 100%;display: block;\"");

      this.$refs["goodsForm"].validate((valid) => {
        if (valid) {
          if (this.pictureList.length == 0) {
            this.messageError("请至少上传一张图片!");
            return;
          }

          if (!this.validateSockList()) {
            return;
          }

          this.goods.picture = this.pictureList[0].url;
          this.goods.pictureList = this.pictureList;

          this.goods.isAttribute = 0;
          this.goods.attributeList = [];
          this.goods.sockList = [];

          //是否有属性
          if (this.sockList.length > 0) {
            this.goods.isAttribute = 1;
            this.goods.attributeList = this.attributeList;
            this.goods.sockList = this.sockList;
          }
          //获取分类
          /*if(this.goods.classifyId.length > 0){
            this.goods.classifyId = this.goods.classifyId[this.goods.classifyId.length-1];
          }*/

          this.goods.contentType = _CONTENT_TYPE_JSON;
          this.simplePost( "/api/mgr/shop/business/goods/addOrUpdate", this.goods, result => {
            if (result.code == "0") {
              this.goods.id = result.data;
              this.message(result.desc);
              this.returnLast();
            } else {
              this.message.error(result.desc);
            }

          });
        } else {
          this.$message.error('请完善商品信息！');
          return false;
        }
      });
    },
    //总库存设置
    totalCodes() {
      var sockList = this.sockList;
      var inventoryNum = 0;
      for (var i = 0, l = sockList.length; i < l; i++) {
        inventoryNum = inventoryNum + parseInt(sockList[i].inventory);
      }
      this.goods.inventory = inventoryNum;
    },
    //批量设置
    batchBut(type) {
      this.batchType = type;
      this.batchValue = '';
      if (type == 1) {
        this.batchTitle = "销售价格设置";
        this.batchName = "销售价格";
      } else if (type == 2) {
        this.batchTitle = "租用价格设置";
        this.batchName = "租用价格";
      } else if (type == 3) {
        this.batchTitle = "出售库存设置";
        this.batchName = "出售库存";
      } else if (type == 4) {
        this.batchTitle = "租赁库存设置";
        this.batchName = "租赁库存";
      } else if (type == 5) {
        this.batchTitle = "重量设置";
        this.batchName = "重量";
      }
      this.batchDialog = true;
    },
    //批量设置保存
    batchSave() {
      var type = this.batchType;
      var values = this.batchValue;
      if (values == null || values == "") {
        this.$message.error("【商品库存】请设置属性值！");
        return;
      }
      if (type == 1) {
        if (!this.validateNumber(values, type)) {
          return;
        }
      } else if (type == 2) {
        if (!this.validateNumber(values, type)) {
          return;
        }
      } else if (type == 3) {
        if (!this.validateInteger(values)) {
          return;
        }
        this.totalCodes();
      } else if (type == 5) {
        if (!this.validateNumber(values, type)) {
          return;
        }
      }
      this.setBatch(type);
      this.batchDialog = false;
    },
    //批量设置值
    setBatch(type) {
      let sockList = this.sockList;

      for (var i = 0, l = sockList.length; i < l; i++) {
        if (type == 1) {
          sockList[i].salesPrice = this.batchValue;
        } else if (type == 2) {
          sockList[i].marketPrice = this.batchValue;
        } else if (type == 3) {
          sockList[i].inventory = this.batchValue;
        } else if (type == 4) {
          sockList[i].marketInventory = this.batchValue;
        } else if (type == 5) {
          sockList[i].weight = this.batchValue;
        }
      }
      this.sockList = sockList;
    },
    //数字验证
    validateNumber(batchValue, type) {
      var reg = /^(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*))$/;
      var state = true;
      if (!reg.test(batchValue)) {
        if (type == 1) {
          this.message.error("【销售价】请输入数字值！");
        } else if (type == 2) {
          this.message.error("【市场价】请输入数字值！");
        } else if (type == 5) {
          this.message.error("【重量】请输入数字值！");
        }

        state = false;
      }
      return state;
    },
    //整数验证
    validateInteger(batchValue) {
      var reg = /^\+?[1-9][0-9]*$/;
      var state = true;
      if (!reg.test(batchValue)) {
        this.$message.error("【库存】请输入整数值！");
        state = false;
      }
      return state;
    },
    //商品库存验证
    validateSockList() {
      var sockList = this.sockList;
      var state = true;
      for (var i = 0, l = sockList.length; i < l; i++) {
        var salesPrice = sockList[i].salesPrice;
        var marketPrice = sockList[i].marketPrice;
        var inventory = sockList[i].inventory;
        var marketInventory = sockList[i].marketInventory;
        if(this.goods.storeGoodsType!=1){
          if (!this.validateNumber(salesPrice, 1)) {
            state = false;
            break;
          }
          if (!this.validateInteger(inventory)) {
            this.$message.error("商品出售库存：请输入整数值！");
            state = false;
            break;
          }
        }
        if(this.goods.storeGoodsType==1||this.goods.storeGoodsType==2){
          if (!this.validateNumber(marketPrice, 2)) {
            state = false;
            break;
          }
          if (!this.validateInteger(marketInventory)) {
            this.$message.error("商品租赁库存：请输入整数值！");
            state = false;
            break;
          }
        }


      }

      var attributeList = this.attributeList;
      for (var ai = 0, al = attributeList.length; ai < al; ai++) {
        if (attributeList[ai].dynamicTags.length == 0) {
          this.$message.error("请填写属性【" + attributeList[ai].name + "】值！");
          state = false;
          break;
        }
      }
      return state;
    },
    arraySpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex < this.stockTitle.length) {
        let item = this.sockList[rowIndex].list[columnIndex];
        if (item.state) {
          return {
            rowspan: item.rowspan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      } else {
        return {
          rowspan: 1,
          colspan: 1
        };
      }
    },
  },
  mounted() {

    if (this.$route.query && this.$route.query.id) {
      this.goods.id = this.$route.query.id;
      this.simpleGet("/api/mgr/shop/business/goods/detail", {id: this.goods.id}, result => {
        this.goods = result.data;
        if(result.data.storeGoodsType==3){
          this.goods.goodsType = 2;
        }
        this.pictureList = this.goods.pictureList;
        this.loadTemplate();
        //设置地址
        this.areaDesc = result.data.areaDesc;
        //设置文本内容
        var goodsDetails = this.goods.goodsDetails;
        this.$refs.editor.init(goodsDetails);

        //设置attributeList
        var goodsAttributeList = result.data.attributeList;
        if (goodsAttributeList.length > 0) {
          var attributeList = new Array();
          for (var i = 0; i < goodsAttributeList.length; i++) {
            var goodsAttribute = goodsAttributeList[i];
            var contentList = goodsAttribute.attributeContentList;
            var cList = new Array();
            for (var ci = 0; ci < contentList.length; ci++) {
              cList.push(contentList[ci].content);
            }
            attributeList.push({
              "name": goodsAttribute.name,
              "inputVisible": false,
              inputValue: "",
              "dynamicTags": cList
            });
          }
          this.goodsStock = true;
          this.attributeList = attributeList;
          this.setStockTitle();

          //设置sockList
          var sockList = new Array();
          var goodsAttributeDetailsList = result.data.sockList;

          for (var i = 0; i < goodsAttributeDetailsList.length; i++) {
            var goodsAttributeDetails = goodsAttributeDetailsList[i];
            sockList.push({
              "list": $.parseJSON(goodsAttributeDetails.listJson),
              "salesPrice": goodsAttributeDetails.salesPrice,
              "marketPrice": goodsAttributeDetails.marketPrice,
              "inventory": goodsAttributeDetails.inventory,
              "codes": goodsAttributeDetails.codes,
              "sales": goodsAttributeDetails.sales,
              "weight":goodsAttributeDetails.weight,
              "marketInventory":goodsAttributeDetails.marketInventory
            });
          }

          this.sockList = sockList;
        }

      });
    }else{
      this.loadTemplate();
    }
  }
}
</script>

<style lang="less" scoped>
.form-title {
  margin-left: 20px;
}

.el-form-item--small {
  margin-top: 10px;
}

.el-input--small {
  width: 215px;
}

.form-but {
  width: 1240px;
  padding: 20px;
  background-color: #FFFFFF;
  text-align: center;
  position: fixed;
  bottom: 0;
  _position: absolute;
  z-index: 2;
  overflow: hidden;
  margin: 0 auto;
}

.attribute-talbe{
  width: 100%;
}

.attribute-talbe table {
  background: #ffffff;
  width: 100%;
  border: 1px solid #E9E9E9;
  color: #333333;
  border-collapse: collapse;
}

.attribute-talbe table > tr > td {
  padding: 4px;
  border: 1px solid #f5f4f4;
}

.attribute-talbe table .tips {
  color: @primary;
}

.attribute-talbe table > tr > td > p, h5 {
  margin: 0px;
}

.attribute-talbe table .attribute-name {
  text-align: center;
  width: 10%;
}

.el-tag--small {
  height: 32px;
  line-height: 32px;
}

.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.attribute-input {
  height: 32px;
  line-height: 32px;
}

.stock-table > tr > td {
  text-align: center;
}

.stock-table > tr > td .width-100 {
  width: 100px;
}

.price-input {
  width: 80px;
}

.batch-but {
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  background: #FFFFFF;
}
</style>
